/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PublicFormSectionResource } from './PublicFormSectionResource';

export type PublicFormResource = {
    id: number;
    name: string;
    url_slug: string;
    availability: {
        status: PublicFormResource.status;
        is_archived: boolean;
        is_disabled: boolean;
        at_capacity: boolean;
        max_entries: number | null;
        current_entries: number;
    };
    settings: {
        description: string | null;
        header_image: string | null;
        date_time_info: string | null;
        confirmation_page: string | null;
        background_color: string;
    };
    theme: {
        id: any;
        background: string | null;
        header: string | null;
        button: string | null;
    };
    /**
     * Non-secret payment descriptors only. Payment processing is a later phase.
     */
    payment: {
        enabled: boolean;
        processor: string | null;
        fund_id: string | null;
        store_payment: boolean;
        price_options: Array<{
            id: number | null;
            name: string;
            amount: number | null;
        }>;
    };
    /**
     * The organization's locale, identical for every viewer. Country fields are null only if the default country is missing.
     */
    locale: {
        /**
         * ISO 3166-1 alpha-2 code
         */
        country_code: string | null;
        date_format: PublicFormResource.date_format | null;
        /**
         * International dialing prefix
         */
        sms_prefix: number | null;
        currency: string | null;
        currency_symbol: string | null;
        /**
         * ISO 639-1 code
         */
        language: string;
        timezone: string | null;
        /**
         * The states or provinces the address form offers, ordered by name. Includes the neighbouring country's for US, Canadian and Mexican organizations (US and Canada show together; Mexico also shows the US), as the legacy form does. Only present when the form asks for an address.
         */
        states?: Array<{
            name: string;
            /**
             * The value submitted for the address `state`
             */
            abbreviation: string;
        }>;
    };
    sections: Array<PublicFormSectionResource>;
};

export namespace PublicFormResource {

    export enum status {
        AVAILABLE = 'available',
        DISABLED = 'disabled',
        AT_CAPACITY = 'at_capacity',
    }

    export enum date_format {
        MDY = 'MDY',
        DMY = 'DMY',
        YMD = 'YMD',
    }


}

